module.exports = __webpack_public_path__ + "static/blog66-6bfeb098ace172aeacb4c6f82abaf8bc.png";